<template>
  <div class="home">
    <!-- Hero 区 -->
    <section id="home" class="hero-section">
      <div class="hero-content">
        <div class="carousel">
          <el-carousel
            :interval="3000"
            arrow="hover"
            class="carousel-container"
            :height="carouselHeight"
          >
            <el-carousel-item v-for="(image, index) in images" :key="index">
              <div class="carousel-image-wrapper">
                <img
                  :src="image.url"
                  :alt="image.name"
                  class="carousel-image"
                  @error="handleImageError(image, index)"
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </section>

    <!-- About 区 -->
    <section id="about" class="about-section">
      <div class="container about-container">
        <div class="section-title company-section">
          <h2>ABOUT US</h2>
          <div class="detail">
            <span>
             Hair Hub Factory During the years since founded in 2015, Hair Hub
              has been only collecting and using top quality human
              hair which are graded from fine human hair to 100% cuticle intact
              Remy human hair. And being a responsible manufacturer and supplier
              both to our clients and society, all our human hair are collected
              ethically, processed in gentle way to hair as well as friendly to
              environment.
            </span>
            <span
              >We always believe that a professional team should provide
              exceptional service to our customers. With our senior R & D,
              technician team, QC team, and sales team who have over 11 years of
              experience in hair processing factory and international business,
              we have been striving to upgrade our processing technology,
              actively creating new products, and will always be happy to help
              you design any hair style or quality occur to your mind.</span
            >
          </div>
        </div>
        <div class="about-content company-content">
          <div class="about-image">
            <img src="../image/about/about.jpg" alt="About Image" />
          </div>
          <div class="about-text">
            <ul class="about-features">
              <li>
                <h3><i class="fa fa-check"></i>Who We Are</h3>
                <span
                  >Hair Hub Factory is an established hair extension
                  production facility dedicated to offering perfect and
                  in-fashion manufacturing solutions to savvy wholesalers,
                  distributors and established global brands who focus on high
                  end human hair products. We do this by identifying and
                  understanding the unique requirements of our clients and
                  crafting out individualized solutions which are professional,
                  reliable and competitively priced.</span
                >
              </li>
              <li>
                <h3><i class="fa fa-check"></i>Our Team</h3>
                <span
                  >We always believe that a professional team plays an important
                  role in providing outstanding customer service to our clients.
                  Leading by our senior R&D, technicians, QC and traders of
                  years’ experience, our team has been striving to actively
                  upgrade processing technology and create new products. We are
                  always happy to help our clients design and create any
                  hairstyle, whether if it is your own idea or in the fashion
                  trend.</span
                >
              </li>
              <li>
                <h3><i class="fa fa-check"></i>Our Clients</h3>
                <span
                  >We collaborate with wholesalers, distributors and established
                  brands all over the world. As a client of Hair Hub Factory
                  , you will experience a timely and professional
                  service. This exceptional service has won a number of loyal
                  clients in over 30 countries and districts including the
                  U.S.A, Germany, France, Russia, Great Britain, Italy, Spain,
                  Australia and etc.</span
                >
              </li>
            </ul>
            <a href="#contact" class="btn primary" @click="openDialog"
              >Contact Us</a
            >
          </div>
        </div>
      </div>
    </section>

    <!-- Product 区 -->
    <section id="product" class="product-section">
      <div class="container product-container">
        <HairProduct></HairProduct>
      </div>
    </section>

    <!-- New Creation 区 -->
    <section id="creation" class="creation-section">
      <div class="container">
        <div class="section-title">
          <h2>New Creations</h2>
          <p>
            To us, every new launch is an adventure. We are always willing to
            put in a great amount of time and money to test our new products.
            Although there are many uncertainties in the process of waiting for
            our clients’ and the market’s final approval, we know what we’ve
            done is worth it because it is our mission to give satisfication to
            our client.
          </p>
        </div>
        <div class="creations-content">
          <div
            class="creations-item"
            v-for="item in newCreationList"
            :key="item.id"
            @mouseenter="hoveredCreations = item.id"
            @mouseleave="hoveredCreations = -1"
            @touchstart="hoveredCreations = item.id"
            @touchend="hoveredCreations = -1"
          >
            <div class="number">{{ item.number }}</div>
            <div class="creations-image-container">
              <img
                :src="item.imageUrl"
                :alt="item.event"
                class="creations-image"
                :class="{ hovered: hoveredCreations === item.id }"
              />
            </div>
            <div class="instruction-box">
              <div class="event">
                <div>
                  <span>{{ item.event }}</span>
                </div>
              </div>
              <div class="line"></div>
              <div class="tip">{{ item.tip }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact 区 -->
    <section id="contact" class="contact-section">
      <div class="container">
        <div class="section-title" onclick="window.open('https://wa.me/+8613729511749', '_blank')">
          <h2>Contact Us</h2>
          <p>Get in touch with our team.</p>
        </div>
        <div class="contact-content">
          <div class="contact-info contact-item">
            <h3>Contact Information</h3>
            <ul>
              <li>
                <i class="fa fa-map-marker"></i>
                <span>Room 405, 4th Floor, Building 1 (Self-numbered)  No. 19 Guangsheng Road, Nansha Street
Nansha District, Guangzhou, Guangdong Province  China, 510000</span>
              </li>
              <li>
                <i class="fa fa-phone"></i>
                <span>+86 13729511749</span>
              </li>
              <li>
                <i class="fa fa-envelope"></i>
                <span>HairHub8899@outlook.com</span>
              </li>
              <li>
                <i class="fa fa-clock-o"></i>
                <span>Monday - Friday: 9am - 6pm</span>
              </li>
            </ul>
            <div class="social-icons">
              <!-- Facebook 图标 - 跳转至Facebook官网（替换为你的账号链接） -->
              <i
                class="fa fa-facebook"
                style="cursor: pointer"
                onclick="window.open('https://www.facebook.com/profile.php?id=61587809636216')"
              ></i>

              <!-- Twitter(X) 图标 - 跳转至Twitter官网（替换为你的账号链接） -->
              <i
                class="fa fa-whatsapp"
                style="cursor: pointer"
                onclick="window.open('https://wa.me/+8613729511749', '_blank')"
              ></i>

              <!-- Instagram 图标 - 跳转至Instagram官网（替换为你的账号链接） -->
              <i
                class="fa fa-instagram"
                style="cursor: pointer"
                onclick="window.open('https://www.instagram.com/hairpiecehub.c0m/')"
              ></i>

<!--              &lt;!&ndash; LinkedIn 图标 - 跳转至LinkedIn官网（替换为你的账号链接） &ndash;&gt;-->
<!--              <i-->
<!--                class="fa fa-linkedin"-->
<!--                style="cursor: pointer"-->
<!--                onclick="window.open('https://www.instagram.com/hairpiecehub.c0m/')"-->
<!--              ></i>-->
            </div>
          </div>
          <!-- Contact 区 原有代码不变，只替换按钮部分 -->
          <div class="contact-form contact-item">
            <h3>Send Us a Message</h3>

            <!-- 原按钮替换为：打开弹窗 -->
            <button type="button" class="btn primary" @click="openDialog">
              Send Message
            </button>

            <!-- 邮件表单弹窗（限制高度+滚动优化） -->
            <!-- 添加自定义类名控制高度 -->
            <el-dialog
              title="Customer Inquiry"
              :visible.sync="dialogVisible"
              width="90%"
              max-width="600px"
              append-to-body
              class="custom-dialog"
            >
              <!-- 表单容器：限制高度+滚动 -->
              <div class="dialog-content-wrapper">
                <el-form
                  :model="emailForm"
                  :rules="emailRules"
                  ref="emailFormRef"
                  label-width="0"
                  class="inquiry-form"
                >
                  <!-- 1. WhatsApp & Email（必填） -->
                  <el-form-item prop="whatsappEmail" class="form-item-custom">
                    <label class="form-label"
                      >1. Would you mind leaving your WhatsApp number and email?
                      <span class="required">*</span></label
                    >
                    <el-input
                      v-model="emailForm.whatsappEmail"
                      placeholder="Please enter your WhatsApp number and email"
                      class="form-input"
                    />
                  </el-form-item>

                  <!-- 2. Purchased human hair before -->
                  <el-form-item class="form-item-custom">
                    <label class="form-label"
                      >2. Have you ever purchased human hair before?</label
                    >
                    <el-select
                      v-model="emailForm.purchasedBefore"
                      placeholder="Please select an option"
                      class="form-input"
                    >
                      <el-option label="Yes" value="Yes"></el-option>
                      <el-option label="No" value="No"></el-option>
                    </el-select>
                  </el-form-item>

                  <!-- 3. Previous purchase source -->
                  <el-form-item class="form-item-custom">
                    <label class="form-label"
                      >3. Where did you purchase human hair from
                      previously?</label
                    >
                    <el-input
                      v-model="emailForm.previousSource"
                      type="textarea"
                      rows="3"
                      placeholder="Please describe your previous purchase channel (e.g. online store, local supplier)"
                      class="form-input"
                    />
                  </el-form-item>

                  <!-- 4. Retailer or Wholesaler -->
                  <el-form-item class="form-item-custom">
                    <label class="form-label"
                      >4. Are you a retailer or a wholesaler?</label
                    >
                    <el-select
                      v-model="emailForm.userType"
                      placeholder="Please select an option"
                      class="form-input"
                    >
                      <el-option label="Retailer" value="Retailer"></el-option>
                      <el-option
                        label="Wholesaler"
                        value="Wholesaler"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <!-- 5. Salon owner or Personal use -->
                  <el-form-item class="form-item-custom">
                    <label class="form-label"
                      >5. Do you own a salon, or is this for personal
                      use?</label
                    >
                    <el-select
                      v-model="emailForm.useType"
                      placeholder="Please select an option"
                      class="form-input"
                    >
                      <el-option
                        label="Salon owner"
                        value="Salon owner"
                      ></el-option>
                      <el-option
                        label="Personal use"
                        value="Personal use"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>

              <!-- 底部按钮居中 -->
              <div slot="footer" class="dialog-footer-custom">
                <el-button @click="dialogVisible = false">Cancel</el-button>
                <el-button type="primary" @click="submitForm"
                  >Submit & Send</el-button
                >
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-logo">
            <a href="#">Hair Hub Factory</a>
<!--            <p>-->
<!--              Creative digital agency with passion for design and innovation.-->
<!--            </p>-->
          </div>
          <div class="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#product">Product</a></li>
              <li><a href="#creation">New Creations</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div class="footer-contact">
            <h4>Contact Info</h4>
            <ul>
              <li>
                <i class="fa fa-map-marker"></i>
                <span>Room 405, 4th Floor, Building 1 (Self-numbered) No. 19 Guangsheng Road, Nansha Street Nansha District, Guangzhou, Guangdong Province China, 510000</span>
              </li>
              <li>
                <i class="fa fa-phone"></i>
                <span>+86 13729511749</span>
              </li>
              <li>
                <i class="fa fa-envelope"></i>
                <span>HairHub8899@outlook.com</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-bottom">
          <p>&copy;Hair Hub Factory.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import HairProduct from "./Product.vue";
import emailjs from "@emailjs/browser";
export default {
  name: "HomeComp",
  components: { HairProduct },
  data() {
    return {
      // 原有数据（保留不动）
      images: [],
      newCreationList: [
        {
          id: "one",
          number: "01/03",
          event: "2016 LAUNCHED BALAYAGE COLORS",
          imageUrl: require("../image/creation/1.jpg"),
          tip: "Ever lifelike, natural looking blended hair color.",
        },
        {
          id: "two",
          number: "02/03",
          event: "2019 NEWLY UP-GRADEDVIRGIN HAIR COLLECTION",
          imageUrl: require("../image/creation/2.jpg"),
          tip: "After times of tests in past months, we proudly announce that our processing technology of Virgin human hair has been all-round upgraded now: 100% cuticle intact, more durable strands,and even pure and clean colors.",
        },
        {
          id: "three",
          number: "03/03",
          event: "2023LAUNCHED MACHINE-INSERTED TAPE IN HAIR EXTENSION",
          imageUrl: require("../image/creation/3.jpg"),
          tip: "As a substitute of the hand-inserted tape in extension launched in 2015, the machine-inserted tape in hair extensions has an advantage of much lower cost and shorter lead time, while it is still as natural as your own hair.",
        },
      ],
      hoveredCreations: -1,
      carouselHeight: "500px",

      // 弹窗表单数据（修改为最新5个问题）
      dialogVisible: false,
      emailFormRef: null,
      emailForm: {
        whatsappEmail: "", // 1. WhatsApp+邮箱
        purchasedBefore: "", // 2. 是否购买过
        previousSource: "", // 3. 之前采购渠道
        userType: "", // 4. 零售商/批发商
        useType: "", // 5. 沙龙/个人使用
      },
      // 验证规则：仅第一项必填
      emailRules: {
        whatsappEmail: [
          {
            required: true,
            message: "WhatsApp & Email is required",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.loadImages();
    this.setCarouselHeight();
    window.addEventListener("resize", this.setCarouselHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCarouselHeight);
  },
  methods: {
    // 加载image文件夹中的图片
    loadImages() {
      try {
        const context = require.context(
          "@/image/home",
          false,
          /\.(png|jpe?g|gif|svg)$/
        );
        const imageList = context.keys().map((key) => ({
          url: context(key),
          name: key.replace(/^\.\/(.*)\.\w+$/, "$1"),
        }));
        this.images = imageList.slice(0, 4);
      } catch (error) {
        console.error("加载图片失败:", error);
        this.loadDefaultImages();
      }
    },

    // 加载默认图片
    loadDefaultImages() {
      this.images = Array.from({ length: 5 }, (_, i) => ({
        url: `https://picsum.photos/seed/carousel${i}/1200/500`,
        name: `默认轮播图 ${i + 1}`,
      }));
    },

    // 处理图片加载失败
    handleImageError(image, index) {
      console.warn(`图片 ${image.name} 加载失败，使用备用图片`);
      image.url = `https://picsum.photos/seed/backup${index}/1200/500`;
    },

    // 跳转社媒
    goIns() {
      const targetUrl = "https://www.baidu.com";
      window.open(targetUrl, "_blank");
    },
    //打开弹窗
    openDialog() {
      this.dialogVisible = true;
    },
    submitForm() {
      this.$refs.emailFormRef.validate(async (valid) => {
        if (!valid) {
          this.$message.warning("Please fill in WhatsApp and Email!");
          return;
        }
        // 表单数据，变量名和模板完全一致
        const params = {
          whatsappEmail: this.emailForm.whatsappEmail,
          purchasedBefore: this.emailForm.purchasedBefore || "Not selected",
          previousSource: this.emailForm.previousSource || "Not filled",
          userType: this.emailForm.userType || "Not selected",
          useType: this.emailForm.useType || "Not selected",
        };

        try {
          await emailjs.send(
            "service_7bihrs7", // 填写网易邮箱对应的Service ID
            "template_hfexrsb", // 填写刚才复制的模板ID
            params,
            "QkTXtKHTvujqe3osT" // 填写Public Key
          );
          this.$message.success("Submitted successfully!");
          this.dialogVisible = false;
          this.$refs.emailFormRef.resetFields();
        } catch (err) {
          this.$message.error("Submission failed, please try again!");
          console.log(err);
        }
      });
    },

    // 响应式设置轮播图高度
    setCarouselHeight() {
      const width = window.innerWidth;
      if (width <= 480) {
        this.carouselHeight = "250px"; // 手机端轮播图高度
      } else if (width <= 768) {
        this.carouselHeight = "350px"; // 平板端轮播图高度
      } else {
        this.carouselHeight = "850px"; // 网页端轮播图高度
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  margin-top: 60px;
  box-sizing: border-box;
  overflow-x: hidden; /* 防止移动端横向滚动 */
}

/* Hero 区样式 */
.hero-section {
  width: 100%;
  padding-bottom: 70px;
  box-sizing: border-box;

  .carousel {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;

    .carousel-container {
      width: 100%;
      margin: 0 auto;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      overflow: hidden;
    }

    .carousel-image-wrapper {
      width: 100%;
      height: 100%;
      position: relative;
    }

    .carousel-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: all 0.3s ease;
    }

    /* 自定义箭头样式 */
    ::v-deep .el-carousel__arrow {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.3);
      opacity: 0.8;
    }

    ::v-deep .el-carousel__arrow:hover {
      background-color: rgba(0, 0, 0, 0.5);
    }

    /* 移动端箭头优化 */
    ::v-deep .el-carousel__arrow--left {
      left: 10px !important;
    }
    ::v-deep .el-carousel__arrow--right {
      right: 10px !important;
    }
  }
}

/* 按钮样式 */
.btn {
  display: inline-block;
  padding: 12px 30px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s;
  border-radius: 4px;
  cursor: pointer;
}

.btn.primary {
  background-color: #000;
  color: #fff;
  margin-right: 15px;
}

.btn.primary:hover {
  background-color: #333;
}

.btn.secondary {
  background-color: #fff;
  color: #000;
}

.btn.secondary:hover {
  background-color: #f5f5f5;
}

/* 通用区块标题 */
.section-title {
  text-align: center;
  margin-bottom: 60px;
  padding: 0 15px;
  box-sizing: border-box;
}

.section-title h2 {
  font-size: 36px;
  margin-bottom: 15px;
}

.section-title p {
  font-size: 16px;
  color: #777;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* 各区块通用间距 */
.about-section,
.product-section,
.creation-section,
.contact-section {
  padding: 70px 0;
  box-sizing: border-box;
}

.container {
  width: 1170px;
  max-width: 100%; /* 关键：限制最大宽度为100% */
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}

/* About 区 */
.about-content {
  display: flex;
  gap: 50px;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
}

.about-image {
  width: 400px;
  max-width: 100%; /* 响应式宽度 */
  padding: 20px;
  box-sizing: border-box;

  img {
    width: 100%;
    border-radius: 4px;
    height: auto; /* 高度自适应 */
  }
}

.about-text {
  flex: 1;
  margin-right: 0; /* 移除固定margin，适配小屏幕 */
  padding: 0 15px;
  box-sizing: border-box;

  h3 {
    font-size: 24px;
    margin-bottom: 20px;
  }

  .about-features {
    list-style: none;
    padding: 0;
    margin-bottom: 30px;

    li {
      margin-bottom: 20px; /* 增大移动端间距，提升可读性 */
      i {
        color: #000;
        margin-right: 10px;
      }
      span {
        font-size: 14px;
        color: #7a7474;
        line-height: 1.6;
        display: block; /* 确保文字换行正常 */
      }
    }
  }
}

/* Product 区 */
.products {
  display: flex;
  gap: 30px;
  flex-wrap: wrap; /* 自动换行 */
}

/* New Creation 区 */
.creations-content {
  display: flex;
  gap: 30px;
  padding: 0 15px;
  box-sizing: border-box;
}

/* Contact 区 */
.contact-content {
  display: flex;
  gap: 50px;
  padding: 0 15px;
  box-sizing: border-box;
}

.contact-info,
.contact-form {
  flex: 1;
  min-width: 300px; /* 防止过窄 */
}

.contact-info h3,
.contact-form h3 {
  font-size: 24px;
  margin-bottom: 30px;
}

.contact-info ul {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.contact-info ul li {
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  line-height: 1.6;
}

.contact-info ul li i {
  color: #000;
  margin-right: 10px;
  margin-top: 5px;
  flex-shrink: 0; /* 防止图标压缩 */
}

.social-icons i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #eee;
  border-radius: 50%;
  color: #000;
  margin-right: 10px;
  text-decoration: none;
  transition: background-color 0.3s, color 0.3s;
  cursor: pointer;
}

.form-group {
  margin-bottom: 20px;
}

.form-control {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #eee;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
}

.form-control:focus {
  outline: none;
  border-color: #000;
}

.contact-form button {
  background-color: #000;
  color: #fff;
  border: none;
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.contact-form button:hover {
  background-color: #333;
}

/* Footer 区 */
.footer {
  background-color: #000;
  color: #fff;
  padding: 80px 0 30px;
  box-sizing: border-box;
}

.footer-content {
  display: flex;
  gap: 50px;
  margin-bottom: 50px;
  padding: 0 15px;
  box-sizing: border-box;
}

.footer-logo,
.footer-links,
.footer-contact {
  flex: 1;
  min-width: 250px; /* 防止过窄 */
}

.footer-logo a {
  font-size: 28px;
  font-weight: bold;
  text-decoration: none;
  color: #fff;
  display: block;
  margin-bottom: 20px;
}

.footer-logo p {
  color: #aaa;
  line-height: 1.6;
}

.footer-links h4,
.footer-contact h4 {
  font-size: 18px;
  margin-bottom: 20px;
}

.footer-links ul {
  list-style: none;
  padding: 0;
}

.footer-links ul li {
  margin-bottom: 10px;
}

.footer-links ul li a {
  color: #aaa;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links ul li a:hover {
  color: #fff;
}

.footer-contact ul {
  list-style: none;
  padding: 0;
}

.footer-contact ul li {
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  line-height: 1.6;
}

.footer-contact ul li i {
  color: #aaa;
  margin-right: 10px;
  margin-top: 5px;
  flex-shrink: 0;
}

.footer-contact ul li span {
  color: #aaa;
}

.footer-bottom {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid #333;
  color: #aaa;
  padding: 0 15px;
}

/* About 区自定义样式 */
.about-container {
  width: 100%;
  box-sizing: border-box;

  .company-section {
    width: 100%;
    margin-bottom: 30px;

    .detail {
      width: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: flex-start;
      flex-wrap: wrap; /* 移动端换行 */
      gap: 20px; /* 增加间距 */

      span {
        display: block;
        width: 40%;
        min-width: 280px; /* 移动端最小宽度 */
        text-align: left;
        font-size: 14px;
        color: #7a7474;
        line-height: 1.6;
      }
    }
  }

  .company-content {
    width: 100%; /* 替换100vw，防止横向滚动 */
    min-height: auto; /* 替换固定height，自适应内容 */
    height: auto;
    background-color: #f7f2ed;
    padding: 30px 15px;
    box-sizing: border-box;
  }
}

/* Product 区自定义样式 */
.product-section {
  .product-container {
    width: 100%; /* 替换100vw */
    padding: 0 15px;
    box-sizing: border-box;
  }
}

/* Creation 区自定义样式 */
.creation-section {
  width: 100%; /* 替换100vw */
  min-height: auto; /* 替换固定height */
  height: auto;
  background-color: #f7f2ed;
  padding: 70px 15px;
  box-sizing: border-box;

  .section-title {
    p {
      font-size: 14px;
      color: #7a7474;
      max-width: 800px;
      line-height: 1.6;
    }
  }

  .creations-content {
    margin-top: 30px;

    .creations-item {
      flex: 1;
      border-radius: 10px;
      min-width: 280px; /* 移动端最小宽度 */

      .number {
        font-size: 20px;
        color: #7a7474;
        margin-bottom: 10px;
      }

      .creations-image-container {
        width: 100%;
        height: 300px; /* 固定图片容器高度，适配所有屏幕 */
        border-radius: 4px;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        position: relative;

        .creations-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease, filter 0.5s ease;

          &.hovered {
            transform: scale(1.25);
            filter: brightness(1.1);
          }
        }
      }

      .instruction-box {
        margin-top: 30px;

        .event {
          height: auto; /* 替换固定height，自适应内容 */
          text-align: left;
          font-size: 14px;
          color: #7a7474;
          display: flex;
          align-content: flex-start;
          justify-content: center;
          flex-direction: column;
          margin-bottom: 10px;
        }

        .line {
          width: 100%;
          height: 1px;
          background: #7a7474;
          margin: 10px 0;
        }

        .tip {
          text-align: left;
          font-size: 12px;
          color: #7a7474;
          line-height: 1.6;
        }
      }
    }
  }
}

/* Contact 区自定义样式 */
.contact-section {
  .container {
    width: 100%; /* 替换100vw */

    .contact-content {
      min-height: auto; /* 替换固定height */
      height: auto;
      background-color: #f7f2ed;
      padding: 30px 15px; /* 替换固定150px padding */
      box-sizing: border-box;

      .contact-item {
        width: 100%; /* 替换40%，移动端全屏 */
        max-width: 500px; /* 网页端最大宽度 */
        margin: 0 auto; /* 居中 */
      }
    }
  }
}

/* ------------------------------
   响应式断点适配（分层优化）
------------------------------ */
/* 大屏平板（≤992px） */
@media (max-width: 992px) {
  .container {
    width: 90%;
  }

  .section-title h2 {
    font-size: 32px;
  }

  .about-content,
  .products,
  .creations-content,
  .contact-content,
  .footer-content {
    flex-direction: column;
    gap: 30px;
  }

  .product-item,
  .creation-item,
  .journal-post {
    width: 100%;
  }

  .footer-content {
    align-items: center; /* footer内容居中 */
  }

  .footer-logo,
  .footer-links,
  .footer-contact {
    width: 100%;
    max-width: 400px;
  }
}

/* 小屏平板/大屏手机（≤768px） */
@media (max-width: 768px) {
  .home {
    margin-top: 70px; /* 适配导航栏高度 */
  }

  .section-title {
    margin-bottom: 40px;
  }

  .section-title h2 {
    font-size: 28px;
  }

  .section-title p {
    font-size: 14px;
  }

  .about-section,
  .product-section,
  .creation-section,
  .contact-section {
    padding: 50px 0;
  }

  .about-text h3 {
    font-size: 20px;
  }

  .creations-item .creations-image-container {
    height: 250px; /* 缩小图片容器高度 */
  }

  .footer {
    padding: 60px 0 20px;
  }

  .footer-logo a {
    font-size: 24px;
  }
}

/* 手机端（≤480px） */
@media (max-width: 480px) {
  .hero-section {
    padding-bottom: 40px;
  }

  .section-title {
    margin-bottom: 30px;
  }

  .section-title h2 {
    font-size: 24px;
  }

  .about-section,
  .product-section,
  .creation-section,
  .contact-section {
    padding: 40px 0;
  }

  .btn {
    padding: 10px 20px;
    font-size: 14px;
    margin-right: 0;
    display: block;
    // width: 100%;
    text-align: center;
    margin-bottom: 15px;
  }

  .about-features li {
    margin-bottom: 15px;
  }

  .about-features li span {
    font-size: 13px;
  }

  .creations-content {
    gap: 40px; /* 增大移动端item间距 */
  }

  .creations-item .creations-image-container {
    height: 200px; /* 进一步缩小图片容器 */
  }

  .creations-item .event span {
    font-size: 13px;
  }

  .creations-item .tip {
    font-size: 11px;
  }

  .social-icons i {
    width: 35px;
    height: 35px;
    font-size: 14px;
  }

  .footer-content {
    gap: 30px;
  }

  .footer-bottom p {
    font-size: 12px;
  }

  /* 轮播图箭头适配手机端 */
  ::v-deep .el-carousel__arrow {
    width: 30px;
    height: 30px;
    font-size: 12px;
  }
}

// 弹窗整体高度限制
.custom-dialog {
  :deep(.el-dialog) {
    max-height: 85vh !important;
    display: flex;
    flex-direction: column;
  }

  // 弹窗内容区：优化内边距，避免遮挡
  :deep(.el-dialog__body) {
    padding: 10px 20px 0 !important; // 底部内边距设为0，交给容器控制
    flex: 1;
    overflow: hidden;
  }

  // 弹窗标题栏：固定高度，避免挤压
  :deep(.el-dialog__header) {
    padding: 15px 20px !important;
    border-bottom: 1px solid #f0f0f0;
  }

  // 弹窗底部按钮区：增加顶部内边距，避免遮挡
  :deep(.el-dialog__footer) {
    padding: 15px 20px 20px !important;
    border-top: 1px solid #f0f0f0;
  }
  :deep(.el-button--primary) {
    background-color: #000;
    border-color: #000;
  }
}

// 表单内容容器：优化高度计算，确保最后一项可见
.dialog-content-wrapper {
  max-height: calc(80vh - 150px) !important; // 多扣除30px，避免底部遮挡
  overflow-y: auto;
  padding: 0 5px;
  margin-bottom: 10px; // 底部留空，避免贴边

  // 滚动条美化
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 3px;
  }
}

// 表单样式：缩小间距 + 优化布局
.inquiry-form {
  .form-item-custom {
    margin-bottom: 0px !important; // 核心：缩小间距（从25px→15px）
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .form-label {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      margin-bottom: 6px !important; // 缩小标签和输入框间距
      line-height: 1.4;
    }

    .required {
      color: #f56c6c;
    }

    .form-input {
      width: 100% !important;
      min-width: 0 !important;
      font-size: 14px;
      // 确保输入框不被截断
      box-sizing: border-box;
    }
  }

  :deep(.el-form-item__content) {
    width: 100%;
    margin-left: 0 !important;
    line-height: 35px;
  }

  // 修复textarea高度，避免占太多空间
  :deep(.el-textarea) {
    width: 100%;
  }
}

// 底部按钮样式
.dialog-footer-custom {
  text-align: center !important;
  padding: 0 !important; // 清空自定义内边距，用el-dialog__footer的样式
}

// 移动端适配
@media (max-width: 480px) {
  .dialog-content-wrapper {
    max-height: calc(80vh - 130px) !important;
    padding: 0 2px;
  }
  .form-label {
    font-size: 13px !important;
  }
  .form-item-custom {
    margin-bottom: 12px !important;
  }
  .inquiry-form {
    :deep(.el-form-item__content) {
      line-height: 20px;
    }
  }
}
</style>